import { cn } from '../cn'

/** Initials of a name or an address: "Henning Meyer" → HM, "hm@avex.de" → HM. */
export function initialsOf(name: string): string {
  const base = name.includes('@') ? name.split('@')[0] : name
  const parts = base.split(/[\s._-]+/).filter(Boolean)
  const letters = parts.length >= 2 ? parts[0][0] + parts[parts.length - 1][0] : base.slice(0, 2)
  return letters.toUpperCase()
}

/**
 * A round avatar with initials, the design system's Avatar. No picture: the
 * accounts have none, and initials read the same in both themes.
 */
export function Avatar({ name, size = 36, className }: { name: string; size?: number; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn('av-avatar', className)}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
    >
      {initialsOf(name)}
    </span>
  )
}
